import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandsSeparator',
  standalone: true
})
export class ThousandsSeparatorPipe implements PipeTransform {
  transform(value: number | string, formatAsDecimal: boolean = false): string {
    let numericValue: number;

    if (typeof value === 'number') {
      numericValue = value;
    } else if (typeof value === 'string' && !isNaN(Number(value))) {
      numericValue = Number(value);
    } else {
      return String(value);
    }

    if (formatAsDecimal) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numericValue);
    } else {
      if (numericValue < 10000) {
        return numericValue.toLocaleString();
      } else if (numericValue < 1000000) {
        const valueInThousands = numericValue / 1000;
        const hasFraction = numericValue % 1000 !== 0;
        const decimalPlaces = hasFraction ? 1 : 0;
        return `${valueInThousands.toFixed(decimalPlaces)}k`;
      } else {
        const valueInMillions = numericValue / 1000000;
        return `${valueInMillions.toFixed(2)}M`;
      }
    }
  }
}
